Namespace 'Monitoring.Models.SocialContents'

class Monitoring.Models.SocialContents.InstagramBusinessDiscoveryListeningContentFactory
  create: (socialContent, allTags) ->
    new Monitoring.Models.SocialContents.InstagramBusinessDiscoveryListeningContent(socialContent)

  canHandle: (socialContent) ->
    socialContent.sub_type == 'instagram_business_discovery_listening_media'
